import React from 'react';
import { Collapse } from 'antd';
import { ScanOutlined } from '@ant-design/icons';
import { PaymentMethod } from '@components/Sections/CoverageSection/CoverageSection';

interface MarkerProps {
  country: string;
  defaultActiveKey?: boolean;
  flag: string;
  paymentMethods: PaymentMethod[];
  style?: React.CSSProperties;
}

const { Panel } = Collapse;

export const MapMarker = ({
  style,
  flag,
  country,
  paymentMethods,
  defaultActiveKey,
}: MarkerProps) => {
  return (
    <div
      className="absolute bg-white shadow-lg rounded-xl w-[120px] md:w-[140px] sm:w-60 z-10"
      style={style}
    >
      <Collapse
        ghost
        defaultActiveKey={defaultActiveKey ? country : undefined}
        expandIcon={() => null}
        className="
          [&>.ant-collapse-item]:border-none
          [&>.ant-collapse-item>.ant-collapse-header]:!p-0
          [&>.ant-collapse-item>.ant-collapse-header]:!h-auto"
      >
        <Panel
          key={country}
          header={
            <div className="flex items-center px-3 py-1  gap-2">
              <span className="text-sm  text-gray-800">{country}</span>
              <img
                src={flag}
                alt={country}
                className="w-6 h-6 sm:w-8 sm:h-8 rounded-full object-cover"
              />
            </div>
          }
        >
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:w-[100px] gap-2 px-1 pt-1 pb-1">
            {paymentMethods.map((method) => (
              <div
                key={method.name}
                className="flex items-center justify-center border rounded-md p-2 w-full"
              >
                {method.name === 'qr' ? (
                  <div className="w-9 h-9 bg-[#f1f5fe] rounded-xl flex items-center justify-center shrink-0">
                    <ScanOutlined style={{ color: '#005fcc', fontSize: 22 }} />
                  </div>
                ) : (
                  <img
                    src={method.icon}
                    alt={method.name}
                    className="w-8 sm:w-10"
                  />
                )}
              </div>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};
